import { useState, useEffect, useRef, Fragment, RawHTML } from '@wordpress/element';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';

import { useGlobalState } from '../state';
import { Container } from '@mui/material';
export default function BeefCollections(props) {
    const { fetchCollections, fetchRecipesFromCollection } = useGlobalState();
    const [collections, setCollections] = useState([]);
    const [header, setHeader] = useState(false);
    const [recipes, setRecipes] = useState([]);
    const { collections: collectionsProp } = props;


    const CollectionCard = (props) => {
        const { collection, index } = props;
        //console.log(collection)
        const image = 'https://' + collection.media[0].links[0].href
        return (
            <Grid item xs={6} sm={4} md={3} key={index}>
                <Card>
                    <CardMedia
                        sx={{ height: 140 }}
                        image={image}
                        title={collection.collectionName}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {collection.collectionName}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" component="div">
                            <RawHTML>{collection.tagline}</RawHTML>
                        </Typography>
                    </CardContent>
                    <CardActions>
                        <Link href={"?collection=" + collection.collectionID} underline="none">View Recipes</Link>
                    </CardActions>
                </Card>
            </Grid>)
    }

    const RecipeCard = (props) => {
        const { recipe, index } = props;
        //console.log(recipe)
        const time = recipe.maxTotalRecipeTimeMinutes;
        const servings = recipe.maxNumberOfServingsInt;
        const calories = recipe.showcaseNutrients[0].unitOfMeasureValue + ' ' + recipe.showcaseNutrients[0].usdaNutrient.nutrientDisplayName;
        const protein = recipe.showcaseNutrients[1].unitOfMeasureValue + recipe.showcaseNutrients[1].unitOfMeasure + ' ' + recipe.showcaseNutrients[1].usdaNutrient.nutrientDisplayName;
        const image = 'https://' + recipe.media[0].links[0].href
        return (
            <Grid item sm={12} md={6} key={index}>
                <Card >
                    <CardMedia
                        sx={{ height: 140 }}
                        image={image}
                        title={recipe.recipeName}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            {recipe.recipeName}
                        </Typography>

                        <Typography gutterBottom variant="body2" component="div">
                            <RawHTML>
                                {recipe.recipeDescription}
                            </RawHTML>
                        </Typography>

                        <Typography variant="subtitle1" color="grey.800" component="div">
                            <Grid container spacing={2}>
                                <Grid item xs={3} key={index + "minutes"}>{time} Minutes</Grid>
                                <Grid item xs={3} key={index + "servings"}>{servings} Servings</Grid>
                                <Grid item xs={3} key={index + "calories"}>{calories}</Grid>
                                <Grid item xs={3} key={index + "protein"}>{protein}</Grid>
                            </Grid>
                        </Typography>


                    </CardContent>
                    <CardActions>
                        <Link size="large" href={"/recipes/recipe?recipe=" + recipe.recipeID} underline="none">View Recipe</Link>
                    </CardActions>
                </Card>
            </Grid>)
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        if (queryParams.get('collection')) {
            fetchRecipesFromCollection({ collection_id: queryParams.get('collection') }).then((data) => {
                setRecipes(data.recipes);
                setHeader({ title: data.title, description: data.description, image: data.image })
            });
        } else {
            fetchCollections(collectionsProp).then((data) => {
                //setCollections(data);
                const collection_ids = data.map((collection) => collection.collectionID);
                const collection_string = collection_ids.toString();

                fetchCollections(collection_string).then((data) => {
                    setCollections(data);
                });
            });
        }

    }, []);
    return (
        <Fragment>
            {header && (
                <Box component="div" sx={{
                    marginBottom: '50px',
                }}>
                    <Grid container key="container">
                        <Grid item xs={12} md={5} sx={{ paddingTop: '0px' }}>

                            <img src={header.image} />
                        </Grid>
                        <Grid item xs={12} md={7} sx={{ background: '#000', padding: '1em', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                            <Typography variant="h2" component="div" sx={{ color: '#fff', textTransform: 'uppercase', textAlign: 'center' }}>
                                {header.title}
                            </Typography>
                            <Typography variant="h6" component="div" sx={{ color: '#fff', textAlign: 'center' }}>
                                {header.description}
                            </Typography>
                        </Grid>
                    </Grid>

                </Box>
            )}
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={{ xs: 2, md: 3 }} key="container">
                    {collections && collections.map((collection, index) => (
                        <CollectionCard collection={collection} index={index} />

                    ))}
                    {recipes && recipes.map((recipe, index) => (
                        <RecipeCard recipe={recipe} index={recipe.recipeID} />
                    ))}
                </Grid>
            </Box>
        </Fragment>
    )
}